import { useState, useEffect } from "react";
import axios from "axios";
import { useAuth, API } from "@/App";

// Lightweight per-session cache of tenant entitlements (feature flags) so the
// Header/Sidebar can gate features without each fetching independently.
let _cache = null;
let _inflight = null;

export function useEntitlements() {
  const { token } = useAuth();
  const [ent, setEnt] = useState(_cache);

  useEffect(() => {
    if (!token) return;
    if (_cache) { setEnt(_cache); return; }
    if (!_inflight) {
      _inflight = axios
        .get(`${API}/subscription/usage`, { headers: { Authorization: `Bearer ${token}` } })
        .then((r) => { _cache = r.data || {}; return _cache; })
        .catch(() => ({}));
    }
    let active = true;
    _inflight.then((d) => { if (active) setEnt(d); });
    return () => { active = false; };
  }, [token]);

  return {
    // default ON unless explicitly disabled by admin
    trainingEnabled: ent?.training_enabled !== false,
    helpFeedbackEnabled: ent?.help_feedback_enabled !== false,
    raw: ent,
  };
}

export default useEntitlements;
